exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-styles-pages-___checkout-fail-page__checkoutMsg___wdp1M{color:#b18433;font-weight:700;text-align:center}.src-components-styles-pages-___checkout-fail-page__link___2GXEV{color:#1f73b7;font-weight:700}", ""]);

// exports
exports.locals = {
	"checkoutMsg": "src-components-styles-pages-___checkout-fail-page__checkoutMsg___wdp1M",
	"link": "src-components-styles-pages-___checkout-fail-page__link___2GXEV"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/sass-loader!./src/components/styles/pages/checkout-fail-page.scss
 ** module id = 917
 ** module chunks = 0
 **/